import script from "./ServicesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesPage.vue?vue&type=script&setup=true&lang=js"

import "./ServicesPage.vue?vue&type=style&index=0&id=5a0d1c90&lang=scss"

const __exports__ = script;

export default __exports__